<template>
    <div id="new-busi-form" :class="fullScreen ? 'full-screen' : ''">
        <div class="new-head">
            <div class="head-left">
                <img src="/images/articleHeadLogo.png" />
                <div class="head-title">
                    <div class="head-span">
                        <span class="moduleT">{{ moduleTitle }}</span>
                        <span>新生信息</span>
                    </div>
                </div>
            </div>
            <div class="head-right">
                <el-button @click="close">
                    <svg-icon style="color: red; margin-right: 5px" icon-class="glyphicon-off" />
                    关 闭
                </el-button>
                <template v-if="canEdit || approval == 1">
                    <el-button v-if="!shareFile || Number(sendToOther) == 1" @click="submitHandle('save')">
                        <svg-icon style="color: red; margin-right: 5px" icon-class="wjzx_sharejl" />保 存
                    </el-button>
                    <el-button v-if="noEdit" type="primary" @click="submitHandle('submit')">
                        <svg-icon style="margin-right: 5px" icon-class="save" />提 交
                    </el-button>
                </template>
            </div>
        </div>
        <div v-if="show" class="busi-box">
            <div class="busi-content">
                <div class="title-info">{{ busiInfo }}</div>
                <div class="busi-components">
                    <busiFormW ref="person" :class="listDataBorder ? 'has-border' : 'no-border'" :vo="vo"
                        :can-edit="canEdit" :module-info="moduleInfo" />
                </div>
            </div>
        </div>
        <select-dialog />
    </div>
</template>

<script>
import { fullScreen, listDataBorder } from '@/wapp/settings'
const moment = require('moment')
export default {
    components: {
    },
    props: {},
    data() {
        return {
            dialogVisible: false,
            receiveObj: {
                receiveType: null,
                receiveUser: '',
                receiveUserId: '',
                returnReason: ''
            },
            voId: '',
            moduleInfo: {
                formTemplate: 'dcontent/busiformurl?vwtype=W&url=/xsgl/freshmanRegistration/form.html',
                winWidth: 1000,
                delUrl: '/xsgl/freshmanRegistration/delete',
                addNewUrl: '/xsgl/freshmanRegistration/addNew',
                insertUrl: '/xsgl/freshmanRegistration/insert',
                moduleCode: 'freshmanRegistration',
                winHeight: 600,
                updateUrl: '/xsgl/freshmanRegistration/update',
                listDataUrl: '/xsgl/freshmanRegistration/listdata',
                getByIdUrl: '/xsgl/freshmanRegistration/getById'
            },
            activeTabIndex: 1,
            vo: {},
            canEdit: 0,
            approval: 0, // 审核状态
            listDataBorder: listDataBorder,
            fileList: [],
            show: false,
            formType: '',
            title: '新生登记',
            formUrl: 'xsgl.freshmanRegistration.form',
            newId: '',
            noEdit: true,
            btnDisabled: false,
            busiInfo: '新生登记',
            loginUser: this.$store.getters.loginUser,
            busiformBtns: [],
            uploadFiles: [],
            formItem: {},
            addChangeUpdate: false,
            moduleTitle: sessionStorage.getItem('setSysMenuName'),
            activeName: '0',
            changeLogVo: {},
            shareFile: false, // 是否为传阅过来的文件
            sendToOther: 0, // 是否可传阅
            defaultBtn: ['submit', 'edit'],
            frmFullScreen: 0, // 是否全屏（表单控制）
            fullScreen: fullScreen // 是否全屏（全局控制）
        }
    },
    computed: {},
    watch: {
        frmFullScreen: {
            handler(val) {
                if (val) {
                    this.fullScreen = true
                }
            },
            immediate: true
        }
    },
    created() {
        document.title = this.busiInfo + ' ' + '-' + ' ' + this.loginUser.sysName
        window.addEventListener('beforeunload', (event) => {
            if (window.opener && window.opener.loadList) {
                window.opener.loadList()
            }
        })
        if (this.$route.query.sendToOther !== undefined) {
            this.shareFile = true
            this.sendToOther = this.$route.query.sendToOther
        }
    },
    beforeDestroy() { },
    mounted() {
        this.vo = {}
        const workform = `#/dcontent/vuebusiform/W/${this.formUrl}.vue`
        if (this.formUrl && this.formUrl.indexOf('@/') > -1) {
            this.$options.components['busiComponent'] = this.$loadComponent(this.$route.query.formUrl)
        } else {
            this.$options.components['busiFormW'] = this.$loadComponent(workform)
        }
        if (this.$route.query.canEdit) {
            this.canEdit = Number(this.$route.query.canEdit)
        }
        if (this.$route.query.approval) {
            this.approval = Number(this.$route.query.approval)
        }
        if (this.$route.query.id) {
            this.voId = this.$route.query.id
            this.getVo(this.voId, this.moduleInfo)
            this.formType = 'update'
        } else {
            this.getVo(null, this.moduleInfo)
            this.canEdit = 1
            this.formType = 'addNew'
        }
        this.moduleInfo.formType = this.formType
    },
    methods: {
        getVo(id, moduleInfo) {
            console.log('id, moduleInfo', id, moduleInfo)
            this.show = false
            if (id) {
                this.$http({
                    method: 'get',
                    url: this.moduleInfo.getByIdUrl,
                    params: {
                        id: id
                    }
                }).then((res) => {
                    if (res.code === 'success') {
                        this.vo = res.body.vo
                    }
                    this.show = true
                    this.$forceUpdate()
                })
            } else {
                this.$http({
                    method: 'post',
                    url: moduleInfo.addNewUrl
                }).then((res) => {
                    if (res.code === 'success') {
                        this.vo = res.body.vo
                        this.show = true
                    }
                })
            }
        },
        // 保存
        submitHandle(type) {
            var _this = this
            console.log('this', this)

            this.$refs.person.formValidate(() => {
                if (!this.voId) {
                    if (type === 'save') {
                        this.vo.reviewApprovalStatus = 0
                        this.$http({
                            method: 'post',
                            url: this.moduleInfo.insertUrl,
                            data: this.vo
                        }).then((res) => {
                            if (res.code === 'success') {
                                // this.vo = res.body.vo
                                location.href = location.href.replace('id=', 'id=' + this.vo.id)
                                this.voId = ''
                                this.$message.success('保存成功')
                                this.refreshTable()
                                setTimeout(() => {
                                    location.reload()
                                }, 1500)
                            } else {
                                this.$alert(res.message, '操作提示', { type: 'warning' })
                            }
                        })
                    } else if (type === 'submit') {
                        this.$confirm('是否确认提交学生信息?', '操作提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.vo.reviewApprovalStatus = 1
                            this.$http({
                                method: 'post',
                                url: this.moduleInfo.insertUrl,
                                data: this.vo
                            }).then((res) => {
                                if (res.code === 'success') {
                                    // this.vo = res.body.vo
                                    location.href = location.href.replace('id=', 'id=' + this.vo.id)
                                    this.voId = ''
                                    this.$message.success('提交成功')
                                    this.close()
                                    // this.refreshTable()
                                    // setTimeout(() => {
                                    //     location.reload()
                                    // }, 1500)
                                } else {
                                    this.$alert(res.message, '操作提示', { type: 'warning' })
                                }
                            })
                        }).catch(() => {
                            // do nothing
                        })
                    }
                } else {
                    if (type === 'save') {
                        // if (this.approval) {
                        //     this.vo.reviewApprovalStatus = 0
                        // } else {
                        //     this.vo.reviewApprovalStatus = 1
                        // }
                        this.$http({
                            method: 'PUT',
                            url: this.moduleInfo.updateUrl,
                            data: this.vo
                        }).then((res) => {
                            if (res.code === 'success') {
                                // this.vo = res.body.vo
                                this.$message.success('保存成功')
                                this.refreshTable()
                            } else {
                                 this.$alert(res.message, '操作提示', { type: 'warning' })
                            }
                        })
                    } else if (type === 'submit') {
                        this.$confirm('是否确认提交学生信息?', '操作提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            if (this.approval) {
                                this.vo.reviewApprovalStatus = 2
                                this.vo.shTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
                                this.vo.shPerson = this.loginUser.personName
                                this.vo.shPersonId = this.loginUser.personId
                            } else {
                                this.vo.reviewApprovalStatus = 1
                            }
                            this.$http({
                                method: 'PUT',
                                url: this.moduleInfo.updateUrl,
                                data: this.vo
                            }).then((res) => {
                                if (res.code === 'success') {
                                    this.$message.success('提交成功')
                                    this.close()
                                    // this.refreshTable()
                                    // setTimeout(() => {
                                    //     window.close()
                                    // }, 1500)
                                } else {
                                     this.$alert(res.message, '操作提示', { type: 'warning' })
                                }
                            })
                        }).catch(() => {
                            // do nothing
                        })
                    }
                }
            }, null, 1)
        },
        close() {
            window.close()
        },
        onSelectTreeDataLoaded: function (treedata, attr) {
            console.log(treedata, 'treedata')
            return treedata
        },
        // 选择人员
        onSelectStaffCompleted(selectedNodes, attr) {
            let selectedNames = ''
            let selectedIds = ''
            selectedNodes.forEach(function (node) {
                if (selectedNames !== '') {
                    selectedNames += '、'
                    selectedIds += ','
                }
                selectedNames += node.name
                selectedIds += node.id
            })
            this.$set(this.receiveObj, 'receiveUser', selectedNames)
            this.$set(this.receiveObj, 'receiveUserId', selectedIds)
        },
        refreshTable() {
            if (window.opener) {
                try {
                    const btnRefresh = window.opener.document.querySelector('.el-icon-refresh')
                    if (btnRefresh !== null) {
                        btnRefresh.parentElement.click()
                    } else {
                        window.opener.postMessage({ messageId: 'refresh' }, '*')
                    }
                } catch (e) {
                    window.opener.postMessage({ messageId: 'refresh' }, '*')
                }
            }
        }

    }
}
</script>
<style scoped lang="scss">
/deep/.el-table__body-wrapper::-webkit-scrollbar {
    height: 8px !important;
}

/deep/.el-table__body-wrapper::-webkit-scrollbar-track {
    border-radius: 12px;
    /*滚动条的背景区域的圆角*/
}

/deep/.el-table__body-wrapper::-webkit-scrollbar-thumb {
    border-radius: 12px;
    /*滚动条的圆角*/
    background-color: #f2f5fb;
    /*滚动条的背景颜色*/
}

/deep/.el-form .el-table__body .tdlbl {
    background: #f2f5fb !important;
}

#new-busi-form {
    height: 100%;
    background: #f0f2f5;

    .new-head {
        height: 68px;
        display: flex;
        justify-content: space-between;
        padding: 0 20px;
        background: white;
        align-items: center;

        .head-left {
            display: flex;
            align-items: center;

            img {
                width: 44px;
                height: 44px;
            }

            .head-title {
                margin-left: 10px;
                font-size: 14px;
                color: #999999;

                .moduleT {
                    margin-right: 13px;
                    position: relative;
                }

                .moduleT::after {
                    position: absolute;
                    content: '';
                    width: 1px;
                    height: 12px;
                    right: -8px;
                    top: 50%;
                    background: #999999;
                    transform: translateY(-50%);
                }
            }
        }
    }

    .busi-box {
        height: calc(100% - 68px);
        overflow: scroll;

        // padding-top: 20px;
        .busi-content {
            width: 1200px;
            padding-bottom: 20px;
            background: white;
            min-height: 100%;
            margin: 0px auto;
            box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.06);

            .title-info {
                height: 93px;
                text-align: center;
                line-height: 93px;
                font-size: 24px;
                color: #000000;
            }

            .busi-components {
                padding: 0 100px;
            }
        }

        @media (max-width: 1600px) {
            .busi-content {
                width: 1000px;
            }
        }

        @media (min-width: 2120px) {
            .busi-content {
                width: 1600px;
            }
        }
    }

    /* 设置滚动条thumb（轨道）的颜色 */
    .busi-box::-webkit-scrollbar {
        background-color: #f0f2f5;
        width: 8px;
    }

    /* 设置滚动条thumb（滑块）的颜色 */
    .busi-box::-webkit-scrollbar-thumb {
        border-radius: 12px;
    }

    /* 设置滚动条hover时thumb的颜色 */
    .busi-box:hover.busi-box::-webkit-scrollbar-thumb {
        background-color: #d5d6d8;
    }

    /deep/.el-table .el-table__header-wrapper .el-table__header thead th {
        background: transparent !important;
    }

    /deep/.el-form .el-table__body .tdlbl .required {
        position: absolute;
        left: 6px;
    }

    /deep/.el-table__cell.tdlbl {
        padding: 4px 6px 4px 15px !important;
    }

    /deep/.el-form .el-table__body .tdlbl {
        text-align: left;
    }

    /deep/.el-form .el-table__body td.tdw17 {
        // width: 15.6% ;
        width: 17.2%;
    }

    /deep/.el-form .el-table__body td.tdw33 {
        width: 34.4%;
    }

    /deep/.el-form .el-table__body td.tdw83 {
        width: 84.4%;
    }

    /deep/.el-form .el-table__body td.tdw13 {
        width: 10.4%;
    }

    /deep/.el-form .el-table__body td.tdw20 {
        width: 22.9%;
    }
}

#new-busi-form.full-screen {
    .busi-content {
        width: calc(100% - 40px);
        min-width: 1000px;

        .busi-components {
            width: calc(100% - 13%);
            margin: 0 auto;
            padding: 0;
        }
    }
}

/deep/.el-table__body-wrapper::-webkit-scrollbar {
    height: 8px !important;
}

/deep/.el-table__body-wrapper::-webkit-scrollbar-track {
    border-radius: 12px;
    /*滚动条的背景区域的圆角*/
}

/deep/.el-table__body-wrapper::-webkit-scrollbar-thumb {
    border-radius: 12px;
    /*滚动条的圆角*/
    background-color: #f2f5fb;
    /*滚动条的背景颜色*/
}

/deep/.el-form .el-table__body .tdlbl {
    background: #f2f5fb !important;
}

#new-busi-form {
    height: 100%;
    background: #f0f2f5;

    .new-head {
        height: 68px;
        display: flex;
        justify-content: space-between;
        padding: 0 20px;
        background: white;
        align-items: center;

        .head-left {
            display: flex;
            align-items: center;

            img {
                width: 44px;
                height: 44px;
            }

            .head-title {
                margin-left: 10px;
                font-size: 14px;
                color: #999999;

                .moduleT {
                    margin-right: 13px;
                    position: relative;
                }

                .moduleT::after {
                    position: absolute;
                    content: '';
                    width: 1px;
                    height: 12px;
                    right: -8px;
                    top: 50%;
                    background: #999999;
                    transform: translateY(-50%);
                }

                .formTapBtn {
                    display: flex;
                    margin-top: 10px;
                    font-family: MicrosoftYaHei;
                    color: #000000;
                    font-size: 14px;

                    .tapItemBtn {
                        position: relative;
                        margin-right: 15px;
                    }

                    .active {
                        position: relative;
                        color: var(--subjectColor);
                        font-weight: bold;

                        &::after {
                            content: '';
                            position: absolute;
                            bottom: -14px;
                            left: 0px;
                            width: 100%;
                            height: 2px;
                            background: var(--subjectColor);
                        }
                    }

                    .tapItemBtn:hover {
                        cursor: pointer;
                        color: var(--subjectColor);
                    }
                }
            }
        }
    }

    .busi-box {
        height: calc(100% - 68px);
        overflow: scroll;

        // padding-top: 20px;
        .busi-content {
            // width: 1200px;
            width: calc(100% - 40px);
            padding-bottom: 20px;
            background: white;
            min-height: 100%;
            margin: 0px auto;
            box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.06);
            margin-top: 20px;

            .title-info {
                height: 93px;
                text-align: center;
                line-height: 93px;
                font-size: 24px;
                color: #000000;
            }

            .busi-components {
                padding: 0 100px;
            }
        }

        @media (max-width: 1600px) {
            .busi-content {
                width: calc(100% - 40px);
            }
        }

        @media (min-width: 2120px) {
            .busi-content {
                width: calc(100% - 40px);
            }
        }
    }

    /* 设置滚动条thumb（轨道）的颜色 */
    .busi-box::-webkit-scrollbar {
        background-color: #f0f2f5;
        width: 8px;
    }

    /* 设置滚动条thumb（滑块）的颜色 */
    .busi-box::-webkit-scrollbar-thumb {
        border-radius: 12px;
    }

    /* 设置滚动条hover时thumb的颜色 */
    .busi-box:hover.busi-box::-webkit-scrollbar-thumb {
        background-color: #d5d6d8;
    }

    /deep/.el-table .el-table__header-wrapper .el-table__header thead th {
        background: transparent !important;
    }

    /deep/.el-form .el-table__body .tdlbl .required {
        position: absolute;
        left: 6px;
    }

    /deep/.el-table__cell.tdlbl {
        padding: 4px 6px 4px 15px !important;
    }

    /deep/.el-form .el-table__body .tdlbl {
        text-align: left;
    }

    /deep/.el-form .el-table__body td.tdw17 {
        // width: 15.6% ;
        width: 15.6%;
    }

    /deep/.el-form .el-table__body td.tdw33 {
        width: 34.4%;
    }

    /deep/.el-form .el-table__body td.tdw83 {
        width: 84.4%;
    }

    /deep/.el-form .el-table__body td.tdw13 {
        width: 10.4%;
    }

    /deep/.el-form .el-table__body td.tdw20 {
        width: 22.9%;
    }

    /deep/.el-form .el-table.el-table--border td {
        border-right-color: #999 !important;
        // border-left-color: #999 !important;
        border-bottom-color: #999 !important;
        // border-top-color: #999 !important;
    }

    /deep/.el-table--border .el-table__cell {
        border-right: 1px solid #999;
    }

    /deep/.el-form .el-table.el-table--border {
        border-color: #999;
    }

    /deep/.el-form .el-table::before {
        background-color: #999;
    }

    /deep/.el-table--border::after,
    .el-table--group::after,
    /deep/.el-table::before {
        background-color: #999;
    }

    /deep/.title-container {
        border-color: #fff !important;
    }

    /deep/.title-container .has-bottom {
        border: 1px solid #999;
        border-bottom: 0px;
    }

    /deep/.el-form .el-table::after {
        background-color: #999;
    }

    /deep/.el-table--border {
        border-color: #999;
    }

    /deep/.el-tabs .el-tabs__header {
        width: 60%;
        background-color: unset;
    }

    /deep/.el-tabs__nav-wrap::after {
        height: 0px;
    }

    /deep/.el-table td.el-table__cell,
    /deep/ .el-table th.el-table__cell.is-leaf {
        border-bottom: 1px solid #999;
    }

    /deep/.toolbar-box .el-button {
        border: 1px solid #999;
    }

    /deep/.el-popover__reference-wrapper .el-button-group .toolbar-box {
        padding: 0 1px 0 0;
    }
}

#new-busi-form.full-screen {
    .busi-content {
        width: calc(100% - 40px);
        min-width: 1000px;

        .busi-components {
            width: calc(100% - 13%);
            margin: 0 auto;
            padding: 0;
        }
    }

    @media (min-width: 3840px) {
        .busi-content {
            width: 3200px;
        }
    }
}
</style>
